"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeSpecimen = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const theme_change_controller_1 = require("@/controllers/theme-change-controller");
require("@/components/common");
/** 스펙시멘이 소개하는 속성. 값은 화면에서 재서 채운다. */
const METRICS = ['font-family', 'font-size', 'line-height'];
/**
 * 한 size 단계의 타이포그래피 스펙시멘.
 * 값을 옮겨 적지 않고 자기가 그린 mm-text에서 실제로 먹은 스타일을 재므로,
 * 토큰이 바뀌거나 크기와 행간의 짝이 바뀌어도 문서가 따라온다.
 */
let TypeSpecimen = class TypeSpecimen extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.themeChange = new theme_change_controller_1.ThemeChangeController(this);
        /** 소개할 mm-text의 size 단계 */
        this.size = '';
        this.values = [];
    }
    render() {
        return (0, lit_1.html) `
      <mm-surface variant="outlined" radius="large">
        <mm-marquee gap="4" speed=${this.speed} pause-on-hover>
          ${METRICS.map((metric, index) => (0, lit_1.html) `
              <mm-text size=${this.size} weight="bold">
                ${metric}: ${this.values[index] ?? ''}
              </mm-text>
            `)}
        </mm-marquee>
      </mm-surface>
    `;
    }
    updated() {
        this.measure();
    }
    /** 큰 글자는 한 바퀴가 길어 같은 속도로는 느리게 읽힌다. 가장 큰 단계만 속도를 올린다. */
    get speed() {
        return this.size === '32' ? '80' : '64';
    }
    measure() {
        const style = getComputedStyle(this.sample);
        const measured = [style.fontFamily, style.fontSize, style.lineHeight];
        if (measured.join() === this.values.join())
            return;
        this.values = measured;
    }
};
TypeSpecimen.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TypeSpecimen.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.state)()
], TypeSpecimen.prototype, "values", void 0);
__decorate([
    (0, decorators_js_1.query)('mm-text')
], TypeSpecimen.prototype, "sample", void 0);
TypeSpecimen = __decorate([
    (0, decorators_js_1.customElement)('mm-type-specimen')
], TypeSpecimen);
exports.TypeSpecimen = TypeSpecimen;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1zcGVjaW1lbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInR5cGUtc3BlY2ltZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUF5RTtBQUV6RSxtRkFBNkU7QUFDN0UsK0JBQTRCO0FBRTVCLHFDQUFxQztBQUNyQyxNQUFNLE9BQU8sR0FBRyxDQUFDLGFBQWEsRUFBRSxXQUFXLEVBQUUsYUFBYSxDQUFVLENBQUE7QUFFcEU7Ozs7R0FJRztBQUVJLElBQU0sWUFBWSxHQUFsQixNQUFNLFlBQWEsU0FBUSxnQkFBVTtJQUFyQzs7UUFNRyxnQkFBVyxHQUFHLElBQUksK0NBQXFCLENBQUMsSUFBSSxDQUFDLENBQUE7UUFDckQsMkJBQTJCO1FBQ0MsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNwQixXQUFNLEdBQWEsRUFBRSxDQUFBO0lBb0N4QyxDQUFDO0lBakNDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztvQ0FFcUIsSUFBSSxDQUFDLEtBQUs7WUFDbEMsT0FBTyxDQUFDLEdBQUcsQ0FDWCxDQUFDLE1BQU0sRUFBRSxLQUFLLEVBQUUsRUFBRSxDQUFDLElBQUEsVUFBSSxFQUFBOzhCQUNMLElBQUksQ0FBQyxJQUFJO2tCQUNyQixNQUFNLEtBQUssSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFOzthQUV4QyxDQUNGOzs7S0FHTixDQUFBO0lBQ0gsQ0FBQztJQUVELE9BQU87UUFDTCxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUE7SUFDaEIsQ0FBQztJQUVELHdEQUF3RDtJQUN4RCxJQUFZLEtBQUs7UUFDZixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQTtJQUN6QyxDQUFDO0lBRU8sT0FBTztRQUNiLE1BQU0sS0FBSyxHQUFHLGdCQUFnQixDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUMzQyxNQUFNLFFBQVEsR0FBRyxDQUFDLEtBQUssQ0FBQyxVQUFVLEVBQUUsS0FBSyxDQUFDLFFBQVEsRUFBRSxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUE7UUFFckUsSUFBSSxRQUFRLENBQUMsSUFBSSxFQUFFLEtBQUssSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLEVBQUU7WUFBRSxPQUFNO1FBRWxELElBQUksQ0FBQyxNQUFNLEdBQUcsUUFBUSxDQUFBO0lBQ3hCLENBQUM7O0FBM0NNLG1CQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7R0FJbEIsQ0FBQTtBQUcyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7MENBQVU7QUFDNUI7SUFBUixJQUFBLHFCQUFLLEdBQUU7NENBQThCO0FBQ3BCO0lBQWpCLElBQUEscUJBQUssRUFBQyxTQUFTLENBQUM7NENBQTZCO0FBVm5DLFlBQVk7SUFEeEIsSUFBQSw2QkFBYSxFQUFDLGtCQUFrQixDQUFDO0dBQ3JCLFlBQVksQ0E2Q3hCO0FBN0NZLG9DQUFZIn0=